// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"7de5b94dd6bb94b64434","293":"42a3e9c1a501b274ec57","518":"c77d72035aec28b0e840","779":"e7fcd4c41f087ce0ce1d"}[chunkId] + ".js";
};